import {AdvancedImage} from '@cloudinary/react';
import {Cloudinary} from "@cloudinary/base";
import {format, quality} from "@cloudinary/base/actions/delivery";
import {auto} from "@cloudinary/base/qualifiers/format";
import {auto as qAuto} from "@cloudinary/base/qualifiers/quality";
// Create a Cloudinary instance and set your cloud name.
const cld = new Cloudinary({
  cloud: {
    cloudName: 'auto-ecole'
  }
});
const CloudinaryImg = ({url}) => {
  // Instantiate a CloudinaryImag bject for the image with the public ID, 'sample'.
  const image = cld.image(url); 
  image
  .delivery(format(auto()))
  .delivery(quality(qAuto()));
  // Render the image in a React component.  plugins={[responsive([800,1000,1200])]}
  return (
      <AdvancedImage cldImg={image}/>
  )

};

export default CloudinaryImg;